import React from "react";
import { Card, CardHeader } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  card: {
    textAlign: "center",
  },
}));

function Ipinfo(props) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardHeader title="" />
      <h2>서브넷 마스크 : {props.subnet}</h2>
      <h2>기본 게이트 웨이 : {props.gateway}</h2>
      <h2>기본 설정 DNS 서버: {props.dns}</h2>
      <h2>보조 DNS 서버: {props.dns2}</h2>
    </Card>
  );
}

export default Ipinfo;
